<template>
  <div>
    <section id="topbar" class="d-flex align-items-center bd-b" style="background: white !important; display: none !important;">
      <div style="max-width: 1200px !important"
        class="container d-flex justify-content-center justify-content-md-between"
      >
        <div class="contact-info d-flex align-items-center"></div>
        <div class="align-items-center contact-links" >
          <a href="#" class="mg-r-10 text-muted bd-r pd-r-10">
            <feather class="mg-r-5" type="globe" :size="16"></feather>Байршил
            <b>Засгийн газрын 12-р байр, Барилгачдын талбай, 4-р хороо, ЧД</b>
          </a>
          <a href="#" class="text-muted">
            <feather class="mg-r-5" type="phone" :size="16"></feather>Холбоо барих <b>1800-0101</b>
          </a>
        </div>
      </div>
    </section>

    <div class="container d-flex justify-content-center" style="max-width: 1200px !important; margin: 0 auto; padding: 0">
      <div style="width: 100%">
        <header id="header" :class="`navbar navbar-header`">
          <a id="mainMenuOpen" class="burger-menu " @click="mainMenuOpen">
            <feather type="menu"></feather>
            <div class="df-logo">
              <img
                :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
                alt
                class="mg-l-10"
                style="max-width: 40px"
              />
              <span class="mg-l-5" v-html="$store.state.app.activeGroup.name"></span>
            </div>
          </a>

          <div class="navbar-menu-wrapper" style="padding-right: 0 !important">
            <div v-if="$store.state.app.isMobile" class="navbar-menu-header">
              <router-link
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: { id: $store.state.app.homePageId, cid: 0 }
                }"
                class="mg-r-10 df-logo"
              >
                <img
                  :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
                  alt
                  class
                  style="max-width: 40px"
                />
                <span class="mg-l-5" v-html="$store.state.app.activeGroup.name"></span>
              </router-link>
            </div>
            <div v-else class="navbar-brand">
              <router-link
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: { id: $store.state.app.homePageId, cid: 0 }
                }"
                class="mg-r-10"
              >
                <img
                  :src="`https://res.gosmart.mn/media/logo/gazar_logo.png`"
                  alt
                  class="df-logo"
                  style="max-height: 50px"
                />
              </router-link>
            </div>

            <div v-if="$store.state.app.isMobile" class="mg-x-10">
              <router-link
                :to="{ name: 'login' }"
                class="btn btn-outline-primary btn-block d-flex justify-content-center"
                type="button"
              >
                <feather type="log-in" class="mg-r-5" size="14"></feather>Нэвтрэх
              </router-link>
            </div>

            <div v-else class="navbar-right">
            <div class="color-brand-01 tx-semibold text-uppercase mg-r-10">Цахим сургалтын системд хандах</div>
              <router-link
                :to="{ name: 'login' }"
                class="btn btn-brand-01 d-flex text-white"
                ><feather type="log-in" class="mg-r-5" size="14"></feather
                >Нэвтрэх</router-link>
                <!-- <a
                href="https://sso.gov.mn/login?response_type=code&client_id=057d410b960645a07272d266-321b86c7e96c291e87e334bafa2cf945&redirect_uri=https%3A%2F%2Fsurgalt.gazar.gov.mn%2Fcore%2Fdan-authorized&scope=W3sic2VydmljZXMiOlsiV1MxMDAxMDFfZ2V0Q2l0aXplbklEQ2FyZEluZm8iXSwid3NkbCI6Imh0dHBzOi8veHlwLmdvdi5tbi9jaXRpemVuLTEuMy4wL3dzP1dTREwifV0=&state=surgalt.gazar"
                class="btn btn-brand-01 d-flex text-white"
                ><feather type="log-in" class="mg-r-5" size="14"></feather
                >Нэвтрэх</a>   -->
            </div>
          </div>
        </header>
      </div>

      
    </div>

    <div class="bg-brand-01">
        <div class="container egazar-nav d-flex justify-content-center" style="max-width: 1200px !important; margin: 0 auto;">
        <ul id="navbarMenu" style="max-width:100%;"
            class="nav navbar-menu order-2 pd-l-30"
          >
            <li
              class="nav-item"
              v-for="(p, i) in pages"
              :key="i"
              :class="{ 'with-sub': getSub(p).length, show: activeId == p.id }"
            >
              <a
                v-if="getSub(p).length"
                @click="activeId = p.id"
                role="button"
                class="nav-link"
                :class="{ active: p.id == $route.params.id }"
                >{{ p.task }}</a
              >

              <router-link
                v-else-if="p.st1=='special'"
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: { id: p.id, cid: 0 }
                }"
                class="nav-link " style="color: white !important; background: #007a3e; border-radius: 3px; padding: 3px 5px;"
                :class="{ active: p.id == $route.params.id }"
                >{{ p.task }}</router-link
              >
              <router-link
                v-else
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: { id: p.id, cid: 0 }
                }"
                class="nav-link"
                :class="{ active: p.id == $route.params.id }"
                >{{ p.task }}</router-link
              >

              <ul v-if="getSub(p).length" class="navbar-menu-sub">
                <li class="nav-sub-item" v-for="(s, i) in getSub(p)" :key="i">
                  <a
                    v-if="s.locTypeCode == 'link'"
                    class="nav-sub-link"
                    :href="s.taskEn"
                    target="_blank"
                  >
                    <feather type="chevron-right"></feather>
                    {{ s.task }}
                  </a>
                  <router-link
                    v-else
                    class="nav-sub-link"
                    :to="{
                      name: $store.state.app.activeGroup.publicPage.route,
                      params: { id: s.id, cid: 0 }
                    }"
                  >
                    <feather type="chevron-right"></feather>
                    {{ s.task }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
// import { request } from "@/api/all";
import { mapActions } from "vuex";
var _ = require("lodash");

export default {
  data() {
    return {
      pages: [],
      activeId: null,
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["handleResponsiveLayoutConfig"]),
    mainMenuOpen() {
      let _obj = this.$store.state.app.responsiveLayout;
      _obj.navbarNavShow = true;
      _obj.backdrop.show = true;
      _obj.backdrop.onCloseEvent = 1;
      _obj.backdrop.removeClassName = "navbar-nav-show";
      this.handleResponsiveLayoutConfig(_obj).then(() => {
        this.toggleBodyClass("addClass", "navbar-nav-show");
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.pages = _.sortBy(
        this.$store.state.app.pages.filter(
          x => x.i2 == 1 && x.i1 == 0 && x.parentId == 0
        ),
        "ord",
        "asc"
      );
      // request({
      //     api: { method: "POST", url: "TaskCore/GetCoreList" },
      //     data: {
      //         skip: 0,
      //         size: 100,
      //         ot: 356,
      //         model:{
      //             isPublic:true
      //         }
      //     },
      //     store: this.$store
      // }).then(res => {
      //     if(res!=false){
      //         this.pages= _.sortBy(res.data.tasks.filter(x => x.i2 == 1 && x.i1 == 0 && x.parentId == 0), "ord", "asc" );
      //         let _home= res.data.tasks.filter(x=>x.st1=='home');
      //         if(_home.length>0){
      //             this.$emit('load-components', _home[0].id);
      //         }
      //     }
      // });
    },
    getSub(p) {
      let pages = _.sortBy(
        this.$store.state.app.pages.filter(
          x => x.i2 == 1 && x.i1 == 0 && x.parentId == p.id
        ),
        "ord",
        "asc"
      );
      // console.log('sdfsdf', p.task, pages.length, this.$store.state.app.pages);
      return pages;
    }
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      this.activeId = null;
    }
  }
};
</script>

<style lang="scss">
.egazar-nav{
  margin: 0 auto;
  max-width: 100%;
  ul{
    li{
      a{
        color: white !important;
        font-weight: 700 !important;
        text-transform: uppercase !important;
        &.active{
          color: #eac514 !important;
        }
        &:hover{
          color: #eac514 !important;
        }
      }
    }
  }
}
</style>
